export enum SliceType {
    "INLINE",
    "CROSSLINE"
}